// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Fs-q","title":"BackImages_title__1C2xX","images":"BackImages_images__1mfcP"};